import { Route } from 'react-router-dom';
import { lazyRoute } from '../lazyRoute';

// The module loads on first visit as one section; its screens split further inside it (VoiceAiSection.tsx)
const VoiceAiSection = lazyRoute(() => import('./VoiceAiSection').then((m) => m.VoiceAiSection));

/** The voice AI module (agent config, test console), under /agencies/:agencyId/voice_ai */
export const voiceAiAgencyRoutes = <Route path="voice_ai/*" element={<VoiceAiSection />} />;
